// src/components/ScrollToTop.jsx
import { useState, useEffect } from 'react'

export default function ScrollToTop() {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const toggleVisibility = () => {
            setIsVisible(window.scrollY > 300)
        }
        window.addEventListener('scroll', toggleVisibility)
        return () => window.removeEventListener('scroll', toggleVisibility)
    }, [])

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    return (
        <button
            onClick={scrollToTop}
            aria-label="Scroll to top"
            className={`
                fixed bottom-6 right-6 z-50
                w-11 h-11 md:w-13 md:h-13 lg:w-14 lg:h-14
                rounded-full
                flex items-center justify-center
                bg-[#07090e] 
                border border-brand-amber/30
                text-brand-amber
                hover:text-white
                hover:bg-brand-amber
                hover:border-brand-amber
                hover:shadow-lg hover:shadow-brand-amber/25
                transition-all duration-300
                hover:scale-110 active:scale-95
                ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}
                focus:outline-none focus:ring-2 focus:ring-brand-amber/50 focus:ring-offset-2 focus:ring-offset-[#07090e]
                group
            `}
        >
            {/* Inner glow ring - visible on hover */}
            <div className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{
                background: 'radial-gradient(circle at center, rgba(212,168,67,0.2) 0%, transparent 70%)',
                transform: 'scale(1.3)',
            }} />

            <svg
                className="w-5 h-5 md:w-6 md:h-6 transition-all duration-300 group-hover:-translate-y-1 group-hover:text-white relative z-10"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <polyline points="18 15 12 9 6 15" />
            </svg>

            {/* Subtle amber pulse ring - always visible */}
            <div className="absolute inset-0 rounded-full border border-brand-amber/10 animate-pulse" style={{ animationDuration: '3s' }} />
        </button>
    )
}